// shared/src/api/endpoints.ts

export const API_ENDPOINTS = {
    // Form endpoints
    FORM_BY_ID: (id: string) => `/api/forms/${id}`,
    FORM_UPLOAD: (id: string) => `/api/forms/${id}/upload`,
    FORM_COMPLETE: (id: string) => `/api/forms/${id}/complete`,
    FORM_DUPLICATE: (id: string) => `/api/forms/${id}/duplicate`,
};